/**
 * Renders a single message segment (text, strongs chip, or verse reference).
 */

import type { StrongsRef } from '@skjv/common';
import type { MessageSegment } from './parse-message-segments';
import { InlineStrongsChip } from './inline-strongs-chip';
import { InlineVerseRef } from './inline-verse-ref';

export function buildStrongsMap(refs?: StrongsRef[]): Map<string, StrongsRef> {
  const map = new Map<string, StrongsRef>();
  if (refs) {
    for (const ref of refs) map.set(ref.number, ref);
  }
  return map;
}

export function renderSegment(
  segment: MessageSegment,
  index: number,
  strongsMap: Map<string, StrongsRef>,
) {
  switch (segment.type) {
    case 'strongs':
      return (
        <InlineStrongsChip
          key={`s-${index}`}
          number={segment.number}
          displayText={segment.displayText}
          preloaded={strongsMap.get(segment.number)}
        />
      );
    case 'verse-ref':
      return (
        <InlineVerseRef
          key={`v-${index}`}
          reference={segment.reference}
          displayText={segment.displayText}
        />
      );
    case 'text':
    default:
      return <span key={`t-${index}`}>{segment.content}</span>;
  }
}
